import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
} from '@angular/core';
import {HelpersService} from '../../services/helpers.service';
import {
    NavigationTableRequestModel,
    NavigationTableResponseItemModel,
    NavigationTableResponseModel,
    PaginationModel,
} from '../../models/file-table.model';
import {DocumentsServiceService} from '../../controllers/documents/documents-service.service';
import {AlertService} from '../../services/notify/alert.service';
import {MemberService} from '../../services/member.service';
import {DocumentsApiService} from '../../services/api/documents-api.service';
import {MemberModel} from '../../models/user.model';
import {ModalService} from '../../services/modal/modal.service';
import {Subscription} from 'rxjs';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ValuePropertyModel} from '../../models/property.model';
import {DocumentHelpersService} from '../../services/helpers/document-helpers.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-component-folder-and-file-table',
    templateUrl: './folder-and-file-table.component.html',
    styleUrls: ['./folder-and-file-table.component.scss'],
})
export class FolderAndFileTableComponent implements OnInit, OnDestroy {
    /* view - default, mini */
    @Input() public view = 'default';

    @Input() public showBackButton = true;

    /** файловый посредник */
    @Input() public $mediator: EventEmitter<NavigationTableResponseModel>;

    /** Требуется авто переподключение медиатора */
    @Input() public isNeedRefreshMediator = false;

    /** события по сортировке или пагинации */
    @Input() public $pagination: EventEmitter<NavigationTableRequestModel> = new EventEmitter();
    @Input() public preparedPagination: NavigationTableRequestModel;

    /** загруженные/подготовленные данные */
    @Input() public data: NavigationTableResponseModel = new NavigationTableResponseModel();

    /** множественный выбор */
    @Input() public isMultiple = false;

    /** возможность выбора или сразу клик */
    @Input() public isSelected = false;

    /** событие на загрузку/обновление данных */
    @Output() public eventFind: EventEmitter<NavigationTableRequestModel | PaginationModel> = new EventEmitter();
    /** событие на выбор записи */
    @Output() public eventSelected: EventEmitter<NavigationTableResponseItemModel[]> = new EventEmitter();
    /** событие на клик по записи */
    @Output() public eventClick: EventEmitter<NavigationTableResponseItemModel> = new EventEmitter();
    subscribe: Subscription;
    refresherSubscribe: Subscription;
    public shadow = false;
    public signers: MemberModel[] = [];
    public files: any;
    public currentUser: MemberModel;
    public allMembers: MemberModel[];
    public isCollection: boolean;
    selectedFolder: NavigationTableResponseItemModel;
    oldName: string;
    selectedItem: NavigationTableResponseItemModel;
    propertyIcon: {
        [key: string]: {
            icon: string,
            tooltip: string
        }
    } = {
        property_file: {
            icon: 'bi bi-file-earmark-word prop_icon',
            tooltip: 'DOCUMENTS',
        },
        property_member: {
            icon: 'bi bi-person prop_icon',
            tooltip: 'MEMBER',
        },
        property_text: {
            icon: 'bbi bi-card-text prop_icon',
            tooltip: 'TEXT',
        },
        property_boolean: {
            icon: 'bi bi-check2-circle prop_icon',
            tooltip: 'BOOLEAN',
        },
        property_catalog: {
            icon: 'bi bi-justify prop_icon',
            tooltip: 'CATALOG',
        },
        property_todo: {
            icon: 'bi bi-clipboard2-check prop_icon',
            tooltip: 'TODO',
        },
    };
    templateItemForSettings: NavigationTableResponseItemModel;
    currentSettings: {
        file?: number[],
        folder?: number[],
        collection?: number[]
    };
    isChecked = true;
    protected request: NavigationTableRequestModel = new NavigationTableRequestModel();
    private copyMembers: MemberModel[];

    constructor(
        public memberService: MemberService,
        public alertService: AlertService,
        public controller: DocumentsServiceService,
        public helper: HelpersService,
        protected documentHelper: DocumentHelpersService,
        public docApi: DocumentsApiService,
        private el: ElementRef,
        public modalService: ModalService,
        public translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (this.preparedPagination) {
            this.data.pagination = this.preparedPagination;
        }

        this.memberService.getCurrentMember().then((result: MemberModel) => {
            this.currentUser = result;
        });
        this.memberService.getAllMembers().then(res => {
            this.allMembers = res;
            this.copyMembers = structuredClone(this.allMembers);
        });

        // обновление данных
        if (this.$mediator) {
            this.mediatorSubs();
        }

        if (this.isNeedRefreshMediator) {
            this.refresherSubscribe = this.controller.refreshMediator.subscribe(() => {
                this.data.loading = true;
                this.subscribe.unsubscribe();
                this.mediatorSubs();
                this.controller.loadNav(this.data.pagination);
            });
        }

        // подписка на пагинацию и сортировку
        this.$pagination.subscribe((pagination: NavigationTableRequestModel) => {
            this.data.loading = true;
            this.eventFind.emit(pagination);
        });

        this.eventFind.subscribe((r: NavigationTableRequestModel) => {
            this.data.loading = true;
            this.request = r;
        });
    }

    mediatorSubs(): void {
        this.data.loading = true;
        this.subscribe = this.$mediator.subscribe((r: NavigationTableResponseModel) => {
            this.data = r;

            if (this.selectedItem) {
                this.selectedItem = (this.data.data as NavigationTableResponseItemModel[]).filter(x =>
                    this.selectedItem.id ? x.id === this.selectedItem.id : x.key === this.selectedItem.key)[0];
            }
            this.data.loading = false;
            if (this.view === 'mini') {
                this.data.data = (this.data.data as NavigationTableResponseItemModel[]).filter(x => !x.contract_guid);
            }

            const settings = localStorage.getItem('folder_settings');

            if (settings) {
                this.currentSettings = JSON.parse(settings);
            } else {
                this.currentSettings = {
                    file: [],
                    collection: [],
                    folder: [],
                };
                localStorage.setItem('folder_settings', JSON.stringify(this.currentSettings));
            }

        });
    }

    ngOnDestroy(): void {
        if (this.subscribe) {
            this.subscribe.unsubscribe();
        }

        if (this.showBackButton) {
            this.controller.refreshMediator.emit();
        }

        if (this.refresherSubscribe) {
            this.refresherSubscribe.unsubscribe();
        }
    }

    itemIsSelected(item: NavigationTableResponseItemModel): boolean {
        if (!this.isSelected) {
            return false;
        }
        if (this.request.filter === 'collection') {
            return item.type_str === 'file';
        } else {
            return item.type_str === 'collection';
        }
    }

    setPage(e: number): void {
        const pagination: NavigationTableRequestModel = this.data.pagination;
        pagination.current_page = e;
        this.$pagination.emit(pagination);
    }

    sortBy(column: string): void {
        let sort = 'desc';
        if (column === this.data.pagination.sort_by) {
            sort = this.data.pagination.sort === 'desc' ? 'asc' : 'desc';
        }
        const pagination: NavigationTableRequestModel = this.data.pagination;
        if (pagination.filter === 'collection') {
            pagination.id = this.data.folder.id;
        }
        pagination.sort_by = column;
        pagination.sort = sort;
        if (!pagination.guid) {
            delete pagination.guid;
        }
        this.$pagination.emit(pagination);
    }

    onSelect(item: NavigationTableResponseItemModel): void {
        const isSelected = item.selected;
        if (!this.isMultiple) {
            this.data.data.map(x => x.selected = false);
        }
        item.selected = !isSelected;

        if (this.isSelected) {
            this.eventSelected.emit((this.data.data as NavigationTableResponseItemModel[]).filter(x => x.selected));
        }
        this.eventClick.emit(item);
    }

    onBack(): void {
        const r: NavigationTableRequestModel = new NavigationTableRequestModel();
        r.id = this.data.folder.pid;

        this.request = r;
        this.eventFind.emit(r);

        if (!this.data.parent) {
            this.data.parent = new NavigationTableResponseItemModel();
            this.data.parent.id = 0;
            this.data.parent.type_str = null;
        }
        this.eventClick.emit(this.data.parent);
    }

    dragover(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (this.data.right.is_upload_file) {
            this.shadow = true;
        }
    }

    dragenter(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (this.data.right.is_upload_file) {
            this.shadow = true;
        }
    }

    drop(event: DragEvent, content: TemplateRef<any>): void {
        this.shadow = false;
        event.preventDefault();
        event.stopPropagation();
        this.files = event.dataTransfer.files;

        const directory = this.controller.request.filter;
        this.isCollection = directory === 'collection';

        if (!this.controller.request.id) {
            this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_COLLECTION'), 'blue');
        } else {
            this.modalService.openTemplateModal(content);
        }
    }

    deleteOrSetSigners(selectedSignerGuid: string): void {
        const addedSigner = this.signers.find(x => x.guid === selectedSignerGuid);

        if (addedSigner) {
            this.allMembers.unshift(addedSigner);
            this.signers = this.signers.filter(x => x.guid !== selectedSignerGuid);
        } else {
            const selectedSigner = this.allMembers.find(x => x.guid === selectedSignerGuid);
            this.allMembers = this.allMembers.filter(x => x.guid !== selectedSignerGuid);
            this.signers.push(selectedSigner);
        }
    }

    uploadFiles(modal: NgbModalRef): void {
        let directory = this.controller.request.filter;
        if (directory !== 'collection') {
            directory = 'folder';
        }

        const dirId = this.controller.request.id;

        const fileData = {
            id: dirId,
            creation: directory,
        };
        let signersGuids: string[];
        if (this.signers.length) {
            signersGuids = this.signers.map(x => {
                return x.guid;
            });
        } else {
            signersGuids = [this.currentUser.guid];
        }

        const fileCreation: any = {
            document: Object.values(this.files),
            file_description: '',
            collection_description: '',
            id: dirId,
            signers: signersGuids,
            one_collection: this.isCollection ? false : this.isChecked,
        };

        fileCreation.document = fileCreation.document.filter((file: File) => {
            const name = file.name.split('.');
            if (!['docx', 'doc', 'pdf', 'docm', 'xls', 'xlsx', 'odt', 'csv'].includes(name.reverse()[0])) {
                return this.alertService.setAlert(this.translate.instant('ALERTS.FORMAT_ERROR', {name: file.name}), 'blue');
            } else {
                return file;
            }
        });

        if (!fileCreation.document.length) {
            modal.close();
            return this.alertService.setAlert(this.translate.instant('ALERTS.UPLOAD_FILE'), 'blue');
        }

        if (fileData.creation === 'folder') {
            this.docApi.createFile(fileCreation).subscribe({
                next: data => {
                    this.documentHelper.setFileToQueue(data);
                    modal.close();
                    this.allMembers = structuredClone(this.copyMembers);
                    this.isChecked = true;
                    this.signers = [];
                }, error: error => {
                    this.alertService.setAlert(error.message, 'blue');
                },
            });
        } else if (fileData.creation === 'collection') {
            this.documentHelper.uploadInCollection({
                file_name: fileCreation.document.name,
                source: fileCreation,
            }, fileData.id);
            this.isChecked = true;
            this.allMembers = structuredClone(this.copyMembers);
            modal.close();
            this.signers = [];
        }
    }

    @HostListener('document: dragenter', ['$event'])
    onDragEnter($event: Event): void {
        if (!this.el.nativeElement.contains($event.target)) {
            $event.preventDefault();
            $event.stopPropagation();
            this.shadow = true;
        }
    }

    @HostListener('document: dragleave', ['$event'])
    onDragLeave($event: Event): void {
        if (!this.el.nativeElement.contains($event.target)) {
            $event.preventDefault();
            $event.stopPropagation();
            this.shadow = false;
        }
    }

    deleteItem(item: NavigationTableResponseItemModel): void {
        let message: string;
        switch (item.type_str) {
            case 'file':
                message = 'DELETE_FILE_NAME';
                break;
            case 'collection':
                message = 'DELETE_COLLECTION_NAME';
                break;
            case 'folder':
                message = 'DELETE_FOLDER_NAME';
                break;
        }

        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.' + message, {name: item.name}),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                switch (item.type_str) {
                    case 'file':
                        this.docApi.deleteFile(item.key).subscribe({
                            next: res => {
                                this.controller.loadNav();
                                this.alertService.setAlert(res.message, 'green');
                            }, error: error => {
                                this.alertService.setAlert(error.message, 'blue');
                            },
                        });
                        break;
                    case 'collection':
                        this.docApi.deleteCollection(item.id).subscribe({
                            next: res => {
                                this.controller.loadNav();
                                this.alertService.setAlert(res.message, 'green');
                            }, error: error => {
                                this.alertService.setAlert(error.message, 'blue');
                            },
                        });
                        break;
                    case 'folder':
                        this.docApi.deleteFolder(item.id).subscribe({
                            next: res => {
                                this.controller.loadNav();
                                this.alertService.setAlert(res.message, 'green');
                            }, error: error => {
                                this.alertService.setAlert(error.message, 'blue');
                            },
                        });
                        break;
                }
            }
        }).catch(() => {
            return;
        });
    }

    afterRefresh(): void {
        if (this.data.pagination.filter === 'collection') {
            this.data.pagination.id = this.data.folder.id;
        }
        this.controller.loadNav(this.data.pagination);
    }

    openPropertiesModal(item: NavigationTableResponseItemModel, content: TemplateRef<any>): void {
        this.selectedItem = item;
        this.modalService.openTemplateModal(content);
    }

    openProfile(event: MouseEvent, user: MemberModel): void {
        event.preventDefault();
        event.stopPropagation();
        this.helper.openProfileByGuid(user.guid);
    }

    openPersonalViewSettings(content: TemplateRef<any>): void {
        this.templateItemForSettings = (this.data.data as NavigationTableResponseItemModel[]).find((x, index) => {
            if (this.data.folder) {
                if (this.data.folder.type_str === 'folder') {
                    if (x.type_str === 'collection') {
                        return x;
                    } else if (++index === this.data.data.length) {
                        return x;
                    }
                } else {
                    return x;
                }
            } else {
                return x;
            }
        });

        this.modalService.openTemplateModal(content);

    }

    changeVision(prop: ValuePropertyModel): void {
        const settings = this.currentSettings[this.templateItemForSettings.type_str];
        if (settings.includes(prop.property.id)) {
            this.currentSettings[this.templateItemForSettings.type_str] = settings.filter(x => x !== prop.property.id);
        } else {
            settings.push(prop.property.id);
        }

        localStorage.setItem('folder_settings', JSON.stringify(this.currentSettings));
    }
}
